import { connect } from 'react-redux';
import VIDsList from './VIDsList';
import { getTranslation } from "../../../reducers/common/localization";
import { fetchGetVIDsForList, getVIDsData, getVIDsLoading, fetchUpdateVID, fetchActivateVID } from './../../../reducers/applicantAccreditations/VIDs';

const mapStateToProps = (state) => {
    return {
        data: getVIDsData(state),
        loading: getVIDsLoading(state),
        translation: getTranslation(state)
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onGetVIDs: () => {
            dispatch(fetchGetVIDsForList());
        },
        onUpdateVID: (id, data) => {
            dispatch(fetchUpdateVID(id, data));
        },
        onActivateVID: (id) => {
            dispatch(fetchActivateVID(id));
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(VIDsList);



// WEBPACK FOOTER //
// ./src/components/applicantAccreditationsManagement/VIDsList/VIDsList.container.js